import { render, staticRenderFns } from "./applicant-header-section.vue?vue&type=template&id=bd1b156e&scoped=true"
import script from "./applicant-header-section.vue?vue&type=script&lang=js"
export * from "./applicant-header-section.vue?vue&type=script&lang=js"
import style0 from "./applicant-header-section.vue?vue&type=style&index=0&id=bd1b156e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1b156e",
  null
  
)

export default component.exports